import { AxiosError, AxiosResponse } from "axios";
import api from "../axios";
import {
  AttachPropertyRequest,
  AttachPropertyResponse,
  MortDocumentUploadResponse,
  PrequalifyRequest,
  PrequalifyResponse,
  SubmitMortgageResponse,
  UploadDocExtMortageReq,
} from "../types/mortgage";
import { log } from "util";

export const mortgagePrequalifyApi = async (req: PrequalifyRequest) => {
  const willPrequalifyForMortgage = new Promise<PrequalifyResponse>(
    (resolve) => {
      api
        .post("/api/MortgageApplication/pre-qualify", req)
        .then((response: AxiosResponse<PrequalifyResponse["data"]>) => {
          resolve({ data: response.data });
        })
        .catch((err: AxiosError | any) => {
          resolve({ error: err });
        });
    }
  );

  return willPrequalifyForMortgage;
};

export const mortgageAttachPropertyApi = async (req: AttachPropertyRequest) => {
  const willAttachProperty = new Promise<AttachPropertyResponse>((resolve) => {
    api
      .post("/api/MortgageApplication/attach-property", req)
      .then((response: AxiosResponse<AttachPropertyResponse["data"]>) => {
        resolve({ data: response.data });
      })
      .catch((err: AxiosError | any) => {
        resolve({ error: err });
      });
  });

  return willAttachProperty;
};

export const submitMortgageApplication = async (applicationId: number) => {
  const willSubmitMortgage = new Promise<SubmitMortgageResponse>((resolve) => {
    api
      .post(`/api/MortgageApplication/submit/${applicationId}`)
      .then((response: AxiosResponse<SubmitMortgageResponse["data"]>) => {
        resolve({ data: response.data });
      })
      .catch((err: AxiosError | any) => {
        resolve({ error: err });
      });
  });

  return willSubmitMortgage;
};
 
export const mortgageDocumentUploadApi = async (
  req: UploadDocExtMortageReq
) => {
  console.log('each document key value', req);
  
  const formData = new FormData();
  formData.append('MortgageApplicationId', String(req.MortgageApplicationId));
  req.DocumentTypes.forEach((type) => formData.append('DocumentTypes', String(type)));
  req.Files.forEach((file) => formData.append('Files', file));
  const willUploadDocuments = new Promise<MortDocumentUploadResponse>(
    (resolve, reject) => {
      api
        .post("/api/MortgageApplication/upload-documents", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response: AxiosResponse<MortDocumentUploadResponse["data"]>) => {
          resolve({ data: response.data });
        })
        .catch((err: AxiosError | any) => {
          reject({ error: err });
        });
    }
  );

  return willUploadDocuments;
};
